import moment from 'moment';

const PASSED_EVENT_TRESHOLD = {
  hours: 15,
  minutes: 0,
  seconds: 0,
};
/**
 * Create UTC Date from ISOString.
 */
export const isoStringToUTCDate = (isoString) => {
  if (!isoString || typeof isoString !== 'string') return null;

  const date = new Date(isoString);

  /* TODO: can isNaN be replaced with Number.isNaN here? */
  /* eslint-disable no-restricted-globals */
  return !(date instanceof Date && !isNaN(date))
    ? null
    : new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
      );
};

/**
 * Checks does passed date is still valid
 * @param date
 * @returns {boolean}
 */
export function isNotExpired(date) {
  const blankString = typeof date === 'string' && date.trim() === '';
  return !!date && !blankString && moment.utc().isBefore(moment.utc(date));
}

/**
 * Checks if the date given is in the past.
 * @param date
 * @returns {boolean}
 */
export function isInPast(date) {
  return moment.utc(date) < moment.utc();
}

/**
 * Checks if the date of the given event with a pre-defined threshold is in the past.
 * @param date
 * @returns {boolean}
 */

export function isEventPassed(date) {
  return moment.utc() > moment.utc(date).set(PASSED_EVENT_TRESHOLD);
}

/**
 * Gets the number of days until a given date.
 * @param date
 * @returns {number}
 */
export function getDaysToDate(date) {
  const then = moment.utc(date);
  const now = moment.utc();

  return then.diff(now, 'days');
}

// sets a suitable threshold for splitting future and past events
export const add15Hours = (date) =>
  date.setHours(date.getHours() + 15, 0, 0, 0);
